<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.phaseTemplates'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>

    <div class="wrapper table-area">
      <vxe-table
        :data="phaseTemplates"
        :loading="loading"
        id="phaseGroupTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="name" :title="$t('text.name')">
          <template v-slot="{ row }">
            <a @click="showRow(row)">{{ row.name }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="140">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="edit(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
            <el-button type="text" size="mini" @click="copy(row)">{{
              $t("action.copy")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRecordId" />
    </drawer>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="40%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="10">
              <el-form-item
                :label="$t('text.name')"
                :prop="'name'"
                :rules="[
                  { required: true, validator: validateName, trigger: 'blur' },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.name" />
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("factory.phaseAndPrice") }}</legend>
          <vxe-table
            :data="phasesCom"
            class="recordsTable"
            size="mini"
            resizable
            round
            highlight-hover-row
            auto-resize
            border
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column width="60px">
              <template v-slot="{ row, rowIndex }">
                <i
                  v-if="rowIndex != 0"
                  class="el-icon-top mgr10"
                  @click="swapSequence(row, rowIndex, 'up')"
                ></i>
                <i
                  v-if="rowIndex + 1 != phasesCom.length"
                  class="el-icon-bottom"
                  @click="swapSequence(row, rowIndex, 'down')"
                ></i>
              </template>
            </vxe-table-column>
            <vxe-table-column field="phaseName" :title="$t('menu.phases')" />
            <vxe-table-column
              field="phaseHour"
              :title="$t('phaseTemplate.phaseHour')"
            >
              <template v-slot="{ row }">
                <el-input
                  size="small"
                  v-model.trim="row.phaseHour"
                  :placeholder="$t('rules.mustFill', [''])"
                />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="period"
              :title="$t('phaseTemplate.period')"
            >
              <template v-slot="{ row }">
                <el-input
                  size="small"
                  v-model.trim="row.period"
                  :placeholder="$t('rules.mustFill', [''])"
                />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="inspect"
              :title="$t('phaseTemplate.inspect')"
              width="50"
            >
              <template v-slot="{ row }">
                <el-checkbox size="small" v-model="row.inspect" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="print"
              :title="$t('action.print')"
              width="50"
            >
              <template v-slot="{ row }">
                <el-checkbox size="small" v-model="row.print" />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="action"
              :title="$t('text.action')"
              width="50"
            >
              <template v-slot="{ row, rowIndex }">
                <el-button type="text" size="mini" @click="remove(rowIndex)">{{
                  $t("text.remove")
                }}</el-button>
              </template>
            </vxe-table-column>
          </vxe-table>
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="70px">
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            { required: true, validator: validateNameEdit, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 复制 -->
    <el-dialog
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      :visible.sync="copyDF"
      width="30%"
    >
      <el-form ref="copyObjForm" :model="copyObj" label-width="70px">
        <el-form-item
          :label="$t('text.name')"
          :prop="'name'"
          :rules="[
            { required: true, validator: validateNameCopy, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="copyObj.name" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="copyDoing"
          size="small"
          @click="copySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="copyDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Util from "@/utils/index.js";
import { page } from "@/utils/mixins.js";
import Show from "./show.vue";
import PhaseTemplate from "@/api/phaseTemplate.js";
import Phase from "@/api/phase.js";

export default {
  mixins: [page],
  components: { Show },
  data() {
    var validateName = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(new Error(self.$t("rules.required", [self.$t("text.name")])));
        return;
      }

      if (self.phaseTemplates.find((f) => f.name === value) != null) {
        callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    var validateNameEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(new Error(self.$t("rules.required", [self.$t("text.name")])));
        return;
      }
      if (
        self.phaseTemplates.filter((s) => s.name === value).length > 0 &&
        !(value === self.row.name)
      ) {
        callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };
    var validateNameCopy = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(new Error(self.$t("rules.required", [self.$t("text.name")])));
        return;
      }
      if (self.phaseTemplates.filter((s) => s.name === value).length > 0) {
        callback(new Error(self.$t("rules.exist", [self.$t("text.name")])));
        return;
      } else {
        callback();
      }
    };

    return {
      phaseTemplates: [],
      //
      showDF: false,
      currentRecordId: null,
      // 新增
      validateName: validateName,
      addDF: false,
      phasesCom: [],
      addObj: {
        name: null,
        phaseTemplateItems: [],
      },
      addDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
      },
      editDoing: false,
      //
      validateNameCopy: validateNameCopy,
      copyDF: false,
      copyObj: {
        name: null,
      },
      copyDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    copy(row) {
      const self = this;
      self.row = row;
      self.copyObj.name = self.row.name + "-复制";
      self.copyDF = true;
    },
    copySubmit() {
      const self = this;
      self.$refs.copyObjForm.validate((valid) => {
        if (valid) {
          self.copyDoing = true;
          PhaseTemplate.copy(self.row.id, self.copyObj).then(function (res) {
            self.copyDoing = false;
            self.copyDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.copySuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    swapSequence(row, rowIndex, type) {
      const self = this;
      const currentRowSequence = row.sequence;
      if (type == "up") {
        const currentRowUpSequence = self.phasesCom[rowIndex - 1].sequence;
        self.phasesCom[rowIndex].sequence = currentRowUpSequence;
        self.phasesCom[rowIndex - 1].sequence = currentRowSequence;
      }
      if (type == "down") {
        const currentRowDownSequence = self.phasesCom[rowIndex + 1].sequence;
        self.phasesCom[rowIndex].sequence = currentRowDownSequence;
        self.phasesCom[rowIndex + 1].sequence = currentRowSequence;
      }
      self.phasesCom.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(self.$t("prompt.confirmDelete"))) {
        PhaseTemplate.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row) {
      this.row = row;
      this.editObj.name = row.name;
      this.editDoing = false;
      this.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          PhaseTemplate.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    add() {
      const self = this;
      self.addObj.name = null;
      self.phasesCom = [];
      self.addDoing = false;
      Phase.findByTenantId().then(function (res) {
        if (res.status === 200) {
          if (res.data != null) {
            self.phasesCom = res.data.map((d, idx) => {
              return {
                phaseId: d.id,
                phaseName: d.name,
                sequence: idx,
                phaseHour: null,
                period: null,
                inspect: false,
                print: false,
              };
            });
          }
        } else {
          self.sysError();
        }
        self.addDF = true;
      });
    },
    remove(rowIndex) {
      this.phasesCom.splice(rowIndex, 1);
    },
    addSubmit() {
      const self = this;
      const phasesComFilter = self.phasesCom.filter(
        (c) => c.phaseHour != null && c.period != null
      );
      if (phasesComFilter.length === 0) {
        self.$message({
          message: self.$t("prompt.atLeastOneValidDataFillIn"),
          type: "warning",
        });
        return;
      }
      for (const item of phasesComFilter) {
        if (!Util.regexQuantity(item.phaseHour)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("phaseTemplate.phaseHour"),
            ]),
            type: "warning",
          });
          return;
        }
        if (!Util.regexQuantity(item.period)) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("phaseTemplate.period")]),
            type: "warning",
          });
          return;
        }
      }
      self.addObj.phaseTemplateItems = phasesComFilter;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.addDoing = true;
          PhaseTemplate.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    showRow(row) {
      this.currentRecordId = row.id;
      this.showDF = true;
    },

    loadData() {
      const self = this;
      self.loadingStart();
      PhaseTemplate.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.phaseTemplates = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>
<style scoped>
</style>